/**
 * Список допустимых ходов для текущего игрока — зеркало server/src/game/sekaAllowedActions.js (локальный движок).
 */
import { DEFAULT_SEKA_CONFIG } from './sekaEngine';

/**
 * @param {import('./sekaEngine').LocalSekaGame} game
 * @returns {Array<{ action: string, label: string }>}
 */
export function buildAllowedActionsForLocalCurrentTurn(game) {
  if (!game || game.gameEnded) {
    return [];
  }
  if (game.gamePhase === 'svarkaBetween') {
    return [];
  }

  const turn = game.currentPlayer;
  const player = game.players[turn];
  if (!player || player.isFolded || player.isSittingOut) {
    return [];
  }
  if (Number(player.chips || 0) <= 0) {
    return [];
  }

  const neededToCall = Math.max(0, game.currentBet - player.currentBet);
  const effectiveCallCost = player.isDark ? Math.floor(neededToCall / 2) : neededToCall;
  const showdownMin = game.config?.showdownMinRound ?? DEFAULT_SEKA_CONFIG.showdownMinRound;

  /** @type {Array<{ action: string, label: string }>} */
  const actions = [];
  actions.push({ action: 'FOLD', label: 'Пас' });

  if (player.isDark) {
    actions.push({ action: 'LOOK', label: 'Посмотреть карты' });
  }

  if (neededToCall > 0) {
    actions.push({ action: 'CALL', label: `Уравнять (${effectiveCallCost})` });
  } else {
    actions.push({ action: 'CHECK', label: 'Чек' });
  }

  actions.push({ action: 'RAISE', label: 'Повысить' });

  if ((game.roundNumber || 0) >= showdownMin) {
    actions.push({ action: 'SHOWDOWN', label: 'Вскрыть' });
  }

  return actions;
}
